import FireStoreParser from 'firestore-parser';

const requests = {};

export function apiRequest(path) {
  if (!requests[path]) {
    requests[path] = fetch(`/data-endpoint/${path}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.documents || data?.fields) {
          try {
            const parsedData = FireStoreParser(data);

            if (parsedData.documents) {
              return parsedData.documents.map((item) => item.fields);
            }
            if (parsedData.fields) {
              return parsedData.fields;
            }
          } catch (e) {
            console.error(e);
          }
        }
        return data;
      });
  }
  return requests[path];
}
